import PropTypes from 'prop-types';
import DropdownSelect from 'components/commons/DropdownSelect';
import { SALE_DATE_FORMAT } from 'lib/SearchFilterUtil';
import OptionList from './OptionList';

const RpDateFilter = function(props) {
    return (
        <DropdownSelect
            label={props.label || 'Date'}
            value={props.value}
            width={props.width || 180}
            active={props.active}
            paddingLess
            fullWidth={props.fullWidth}
            showValueAsTooltip={props.showValueAsTooltip}
        >
            <OptionList
                options={props.options}
                onChange={props.onChange}
                format={props.format || SALE_DATE_FORMAT}
                value={props.value}
                isCustomDate={props.isCustomDate}
                displayRight={props.displayRight}
            />
        </DropdownSelect>
    );
};

RpDateFilter.propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    active: PropTypes.bool,
    displayRight: PropTypes.bool,
    paddingLess: PropTypes.bool,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
    format: PropTypes.string,
    isCustomDate: PropTypes.bool.isRequired,
    fullWidth: PropTypes.bool,
    showValueAsTooltip: PropTypes.bool,
};

export default RpDateFilter;